var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CartItemsHandler } from "./CartItems";
import { BookingSlotHandler } from "./BookingSlotHandler";
import { ParticipantFormHandler } from "./Participant/ParticipantFormHandler";
import { BillRecipientFormHandler } from "./BillRecipient/BillRecipientFormHandler";
import { FormState } from "./FormState";
import get from "lodash/get";
import set from "lodash/set";
import size from "lodash/size";
import omit from "lodash/omit";
import merge from "lodash/merge";
var BookingFormManager = /** @class */ (function () {
    function BookingFormManager(modelManager, form, handlers, options) {
        if (options === void 0) { options = {}; }
        this.modelManager = modelManager;
        this.form = form;
        this.handlers = handlers;
        this.options = options;
    }
    Object.defineProperty(BookingFormManager.prototype, "state", {
        get: function () {
            return this.getState();
        },
        enumerable: false,
        configurable: true
    });
    BookingFormManager.prototype.getDirtyForm = function (defaultValues) {
        if (defaultValues === void 0) { defaultValues = {}; }
        var formState = new FormState(this.modelManager, this.form, this.options);
        formState.setFormDefaultValues(defaultValues);
        return formState;
    };
    BookingFormManager.prototype.getState = function (defaultValues) {
        var formValues = this.getDirtyForm(defaultValues);
        for (var _i = 0, _a = this.handlers; _i < _a.length; _i++) {
            var handler = _a[_i];
            formValues = handler.getState(formValues);
        }
        formValues.derive();
        return formValues;
    };
    BookingFormManager.prototype.toJSON = function (defaultValues) {
        var formValues = this.getState(defaultValues);
        for (var _i = 0, _a = this.handlers; _i < _a.length; _i++) {
            var handler = _a[_i];
            formValues = handler.toJSON(formValues);
        }
        return formValues.toJSON();
    };
    BookingFormManager.prototype.toRequestBody = function (fieldPaths) {
        if (fieldPaths === void 0) { fieldPaths = []; }
        var initialState = this.getState();
        var resolvedState = this.getState();
        var toWaitList = resolvedState.toWaitList;
        for (var _i = 0, _a = this.handlers; _i < _a.length; _i++) {
            var handler = _a[_i];
            resolvedState = handler.toRequestBody(resolvedState, fieldPaths, initialState);
        }
        var state = resolvedState.toRequestBody();
        return __assign({ toWaitList: toWaitList }, state);
    };
    BookingFormManager.prototype.mergedCartItems = function (cartItems) {
        var _a;
        var formValues = this.state;
        for (var _i = 0, _b = this.handlers; _i < _b.length; _i++) {
            var handler = _b[_i];
            cartItems = ((_a = handler.mergeCartItems) === null || _a === void 0 ? void 0 : _a.call(handler, cartItems, formValues)) || cartItems;
        }
        return cartItems;
    };
    BookingFormManager.prototype.mergeCart = function (cartItems) {
        return new BookingFormManager(this.modelManager, __assign(__assign({}, this.form), { booking_data: __assign(__assign({}, this.form.booking_data), { cart_items: this.mergedCartItems(cartItems) }) }), this.handlers, this.options);
    };
    BookingFormManager.prototype.getPriceBreakup = function () {
        var formState = this.state;
        if (!formState.rootCartItems.length) {
            return [];
        }
        return formState.filteredCartItems
            .reduce(function (prices, cartItem) {
            var timespan = cartItem.timespan, quantity = cartItem.quantity;
            if (Number(quantity) <= 0) {
                return prices;
            }
            if (!timespan) {
                return prices;
            }
            return prices.concat(cartItem.getAsRowItem());
        }, []);
    };
    BookingFormManager.prototype.setCampaignName = function (campaigns) {
        set(this.options, "campaigns", campaigns || undefined);
    };
    return BookingFormManager;
}());
export { BookingFormManager };
export var getBookingFormManager = function (_a, options) {
    var modelManager = _a.modelManager, form = _a.form;
    if (options === void 0) { options = {}; }
    if (!size(omit(form, "customerId")) && get(options, "defaultFormData.booking_data.booking_id")) {
        form = merge({}, { booking_data: get(options, "defaultFormData.booking_data") }, form);
    }
    return new BookingFormManager(modelManager, form, [
        new CartItemsHandler(modelManager, form, options),
        new BookingSlotHandler(modelManager, form, options),
        new BillRecipientFormHandler(modelManager, form, options),
        new ParticipantFormHandler(modelManager, form, options),
    ], options);
};
